import React from "react";
import { View } from "react-native-web";

const InnerBox = ({ children, bgColor="#FFF"}: any) => {
    return (
    <View
        style={{
          shadowColor: "#000",
          shadowOpacity: 0.1,
          shadowRadius: 12,
          height: "80%",
          backgroundColor: bgColor,
          borderRadius: 30,
          alignItems: "center",
          justifyContent: "flex-start",
          padding: 8,
          width: "95%",
          marginTop: 120,
          overflow: "scroll",
        }}
      >
            {children}
    </View>
    )
}

export default InnerBox;